import { render, staticRenderFns } from "./EducationDialog.vue?vue&type=template&id=50316274&scoped=true&"
import script from "./EducationDialog.vue?vue&type=script&lang=js&"
export * from "./EducationDialog.vue?vue&type=script&lang=js&"
import style0 from "./EducationDialog.vue?vue&type=style&index=0&id=50316274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50316274",
  null
  
)

export default component.exports